export const getUITheme = state => state.theme;
